import { check_empty_field, check_if_number } from "../../pages/Forms/validationChecks";

export function isValidBillsItems(otherRecurringBillsItems, setState) {
    return new Promise((resolve, reject) => {
      setState((prevState) => {
        let foundError = false;
        otherRecurringBillsItems = prevState.otherRecurringBillsItems.map((item, index) => {
          let billError = "";
          let amountError = "";
          if (!(item.bill.length === 0 && item.amount.length === 0)) {
            billError = check_empty_field(item.bill);
            amountError = check_empty_field(item.amount) || check_if_number(item.amount.toString());
          }
          if (!foundError) {
            foundError = billError.length > 0 || amountError.length > 0;
          }
          return {
            bill: billError,
            amount: amountError
          };
        });
        return {
          errors: {
            ...prevState.errors,
            otherRecurringBillsItems
          }
        };
      }, () => {
        const hasError = otherRecurringBillsItems.some((item) => item.bill.length > 0 || item.amount.length > 0);
        resolve(!hasError);
      });
    });
  }

export function handleChangeBillsAmount(index, event) {
    const key = 'amount';
    const { value } = event.target;

    this.setState((prevState) => {
        const { otherRecurringBillsItems } = prevState;
        const updatedItems = [...otherRecurringBillsItems];
        updatedItems[index] = { ...updatedItems[index], [key]: value };
        return { otherRecurringBillsItems: updatedItems };
    }, () => {
        isValidBillsItems(this.state.otherRecurringBillsItems, this.setState.bind(this));
    });
}

export function handleChangeBillsOptions(index, selected, propsItems, options) {
    this.setState((prevState) => {
        const { otherRecurringBillsItems } = prevState;
        otherRecurringBillsItems[index]["bill"] = selected;

        return {
            otherRecurringBillsItems,
            otherRecurringBillsItemOptions: getBillsOptions(otherRecurringBillsItems, propsItems, options)
        };
    }, () => {
        isValidBillsItems(this.state.otherRecurringBillsItems, this.setState.bind(this));
    });
}

export function getBillsOptions(otherRecurringBillsItems, propsItems, options) {
let alreadySelected = [];

for (let item of otherRecurringBillsItems) {
    if (item.bill.length > 0) {
    alreadySelected.push(item.bill[0].label || item.bill[0]);
    }
}

if (propsItems) {
    for (let item of propsItems) {
    alreadySelected.push(item.bill || item.bill[0].label);
    }
}

const allItems = [...alreadySelected, ...options.otherRecurringBillItems];

const otherRecurringBillsItemOptions = allItems.filter(
    (billName) => !alreadySelected.includes(billName)
);

return otherRecurringBillsItemOptions;
}

export function getBillsItems(item) {
return {
    bill: [getBillsName(item.bill)],
    amount: item.amount ? item.amount.toString() : ""
};
}

export function getBillsName(billName) {
return { id: billName, label: billName };
}

export function handleAddItem (){
this.setState((prevState) => ({
    otherRecurringBillsItems: [
    ...prevState.otherRecurringBillsItems,
    { bill: [], amount: "" }
    ],
    errors: {
    ...prevState.errors,
    otherRecurringBillsItems: [
        ...prevState.errors.otherRecurringBillsItems,
        { bill: "", amount: "" }
    ]
    }
}));
};

export function handleDeleteItem (index){
this.setState((prevState) => {
    const otherRecurringBillsItems = [...prevState.otherRecurringBillsItems];
    const errors = [...prevState.errors.otherRecurringBillsItems];

    otherRecurringBillsItems.splice(index, 1);
    errors.splice(index, 1);

    return {
    otherRecurringBillsItems,
    errors: { ...prevState.errors, otherRecurringBillsItems: errors }
    };
});
};
